import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/thelesscompany.webp';
import screenshot_target from '../../../images/letterfunnel/bastiaanvanhamersveld.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Bastiaan van Hamersveld"
      firstname="Bastiaan"
      companyname="The LeSS Company"
      competition="Scaled Agile en Scrum.org"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/bastiaanvanhamersveld.js